@if (matcher$ | async; as matcher) {
  <div class="flex layout-col">
    <elder-label-input
      name="allowedMaterialIds"
      label="{{ 'materials.allowed-ids' | translate }}"
      [(value)]="matcher.allowedMaterialIds"
    >
    </elder-label-input>
    <elder-label-input
      name="allowedMaterialGroups"
      label="{{ 'materials.allowed-groups' | translate }}"
      [(value)]="matcher.allowedMaterialGroups"
    >
    </elder-label-input>
    <elder-label-input
      name="allowedMaterialTypes"
      label="{{ 'materials.allowed-types' | translate }}"
      [(value)]="matcher.allowedMaterialTypes"
    >
    </elder-label-input>
    <elder-label-input
      name="allowedMaterialHierarchies"
      label="{{ 'materials.allowed-hierarchies' | translate }}"
      [(value)]="matcher.allowedMaterialHierarchies"
    >
    </elder-label-input>
  </div>
}
